import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { releaseOfferRequestForAdminApi } from './releaseOfferRequestForAdmin.api'
import { releaseOfferRequestForAdminInitialState } from './releaseOfferRequestForAdmin.initialState'
import {
  ReleaseOfferRequestForAdminErrorResponse,
  ReleaseOfferRequestForAdminRequest
} from './releaseOfferRequestForAdmin.types'

export const releaseOfferRequestForAdminThunk = createAsyncThunk(
  urls.offers.releaseOfferRequest,
  async (request: ReleaseOfferRequestForAdminRequest, { rejectWithValue }) => {
    try {
      const response = await releaseOfferRequestForAdminApi(request)

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const releaseOfferRequestForAdminSlice = createSlice({
  name: 'releaseOfferRequestForAdmin',
  initialState: releaseOfferRequestForAdminInitialState,
  reducers: {
    resetReleaseOfferRequestForAdmin: (state) => {
      state.data = null
      state.loading = false
      state.error = null
      state.success = false
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(releaseOfferRequestForAdminThunk.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = false
      })
      .addCase(releaseOfferRequestForAdminThunk.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
        state.success = true
        state.error = null
      })
      .addCase(releaseOfferRequestForAdminThunk.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as ReleaseOfferRequestForAdminErrorResponse
        state.success = false
      })
  }
})

export const { resetReleaseOfferRequestForAdmin } = releaseOfferRequestForAdminSlice.actions

export default releaseOfferRequestForAdminSlice.reducer
